export default __webpack_public_path__ + "static/media/1.f9af12d6.png";